import React, {useEffect, useState, useCallback} from 'react';
import {withRouter, useParams, Link} from 'react-router-dom';
import {useDispatch} from "react-redux";
import {Menu} from '../../utils/menu/Menu';
import {
  roleEditAction,
  roleGetAction,
  rolesAction
} from '../../actions/rolesAction';
import {formatErrors} from '../../constants';
import {toast} from 'react-toastify';
import {InputProfile} from "../../utils/input/InputProfile";

function Role(props) {
    const dispatch = useDispatch();
    const {id} = useParams();
    const [item, setItem] = useState(null);
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState(null);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState(null);
    const {history} = props;

    const getList = useCallback(() => {
      dispatch(rolesAction()).then((res) => {
        setItems(res.list || []);
      }).catch(err => {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    }, [dispatch]);
  
    const getRole = useCallback((id) => {
      dispatch(roleGetAction(id)).then((data) => {
        setItem(data);
        setForm({
          id: data.id,
          name: data.name,
          role_id: 0
        });
      }).catch(err => {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    }, [dispatch]);
  
    const handleChangeForm = (e) => {
      const {name, value} = e.target;
      setForm(prev => ({...prev, [name]: value}));
      setErrors(prev => ({...prev, [name]: value.trim() === ''}));
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      if (loading) return;
  
      const errs = {};
      if (!form.name) errs.name = true;
  
      setErrors(errs);
      if (Object.keys(errs).length > 0) return;
  
      setLoading(true);
      form.role_id = isNaN(form.role_id) ? 0 : +form.role_id;
      dispatch(roleEditAction(form)).then(() => {
        setLoading(false);
        toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
        history.push('/roles');
      }).catch((e) => {
        setLoading(false);
        toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    };

    useEffect(() => {
      if (id && id !== '0') {
        getRole(id);
      } else {
        setForm({ id: 0, name: '', role_id: 0 });
        getList();
      }
    }, [id, getRole, getList]);

  return <div className="content">
    <Menu />

    <header className="header header--nav">
      <Link to={'/roles'} className="header__link">Роли</Link>
    </header>

    {form && <div className="profile">
      <form className="profile__wrapper" noValidate onSubmit={handleSubmit}>
        <span className="profile__heading">Роль</span>
        {item && <h4 className="profile__name">{item.name}</h4>}

        <div className="profile__inner profile__inner--group">
          <div className="profile__wrap">
            <InputProfile type="text"
                          title="Название"
                          name="name"
                          placeholder="Введите название"
                          value={form.name}
                          error={errors.name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
            {items && <div className="profile__group">
                <label className="profile__label help">Копировать права с роли:</label>
                <select name="role_id"
                  className={"dropdown__select select"}
                  style={{marginTop: 0}}
                  value={form.role_id}
                  disabled={loading}
                  onChange={handleChangeForm}>
                  <option value={0}>Не выбрано</option>
                  {items.map((i, k) => <option key={'role_id_' + k} value={i.id}>{i.name}</option>)}
                </select>
              </div>}
          </div>
        </div>

        <button className="profile__btn btn">Сохранить</button>
      </form>
    </div>}
  </div>;
};

export default withRouter(Role);
